import { AppError } from './app-error';

export class NotAuthenticatedError extends AppError {
  public constructor() {
    super('not-authenticated', 'Not Authenticated');
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = NotAuthenticatedError.name;
  }
}
